import { render } from "./PageNotFound.vue?vue&type=template&id=2e06c763"
const script = {}

import exportComponent from "/home/runner/work/solana-twitter/solana-twitter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__